import { render, staticRenderFns } from "./orders-statistics.vue?vue&type=template&id=dd26c1e8"
import script from "./orders-statistics.vue?vue&type=script&lang=js"
export * from "./orders-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports